import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Monit from './components/Monit';
import { getAuth } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

// --- MUI Imports ---
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// --- הגדרת Theme עבור עברית (RTL) ---
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

const theme = createTheme({
  direction: 'rtl',
});

export default function MonitPage() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const auth = getAuth();

    useEffect(() => {
        const checkAccess = async () => {
            if (!auth.currentUser) {
                navigate('/');
                return;
            }
            setLoading(false);
        };

        checkAccess();
    }, [auth.currentUser, navigate]);

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-900 flex items-center justify-center">
                <div className="text-white text-xl">טוען...</div>
            </div>
        );
    }

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="min-h-screen bg-gray-900 text-white p-4">
                        <div className="max-w-4xl mx-auto">
                            <div className="mb-6">
                                <h1 className="text-3xl font-bold text-amber-400 mb-2">הזמנת נסיעה</h1>
                                <p className="text-gray-300">בחר סוג נסיעה ובדוק זמינות</p>
                            </div>

                            <Monit effectiveUserId={auth.currentUser?.uid} />

                            <div className="mt-6 text-center">
                                <button 
                                    onClick={() => navigate('/')}
                                    className="bg-amber-500 hover:bg-amber-600 text-black font-bold py-2 px-6 rounded-lg transition-colors"
                                >
                                    חזרה לעמוד הראשי
                                </button>
                            </div>
                        </div>
                    </div>
                </LocalizationProvider>
            </ThemeProvider>
        </CacheProvider>
    );
} 